import {
  LayoutDashboard,
  Brain,
  Package,
  Box,
  RefreshCw,
  Users,
  Users2,
  Boxes,
  Plus,
  MapPin,
  ArrowLeftRight,
  Repeat,
  Wrench,
  Droplet,
  Car,
  Recycle,
  ChartBar,
  Settings,
  LineChart,
  ShoppingCart,
  Leaf
} from 'lucide-react';

export const navigation = [
  {
    name: 'Dashboard',
    description: 'Overview and key metrics',
    href: '/admin/dashboard',
    icon: LayoutDashboard
  },
  {
    name: 'AI & Agents',
    description: 'AI and agent management',
    href: '/admin/ai',
    icon: Brain,
    items: [
      {
        name: 'Dashboard',
        description: 'AI overview',
        href: '/admin/ai',
        icon: LayoutDashboard
      },
      {
        name: 'Skills',
        description: 'Agent skills',
        href: '/admin/ai/skills',
        icon: Brain
      },
      {
        name: 'Policies',
        description: 'Agent policies',
        href: '/admin/ai/policies',
        icon: Settings
      },
      {
        name: 'Learning',
        description: 'Agent learning',
        href: '/admin/ai/learning',
        icon: ChartBar
      }
    ]
  },
  {
    name: 'Customers',
    description: 'Customer management',
    href: '/admin/customers',
    icon: Users2,
    items: [
      {
        name: 'All Customers',
        description: 'View all customers',
        href: '/admin/customers',
        icon: Users2
      },
      {
        name: 'Segments',
        description: 'Customer segments',
        href: '/admin/customers/segments',
        icon: Users
      },
      {
        name: 'Analytics',
        description: 'Customer analytics',
        href: '/admin/customers/analytics',
        icon: LineChart
      }
    ]
  },
  {
    name: 'Products',
    description: 'Product management',
    href: '/admin/products',
    icon: Package,
    items: [
      {
        name: 'Dashboard',
        description: 'Products overview',
        href: '/admin/products/dashboard',
        icon: LayoutDashboard
      },
      {
        name: 'All Products',
        description: 'View all products',
        href: '/admin/products',
        icon: Boxes
      },
      {
        name: 'New Product',
        description: 'Create new product',
        href: '/admin/products/new',
        icon: Plus
      }
    ]
  },
  {
    name: 'Inventory',
    description: 'Inventory management',
    href: '/admin/inventory',
    icon: Box,
    items: [
      {
        name: 'Dashboard',
        description: 'Inventory overview',
        href: '/admin/inventory',
        icon: LayoutDashboard
      },
      {
        name: 'Items',
        description: 'Inventory items',
        href: '/admin/inventory/items',
        icon: Box
      },
      {
        name: 'Locations',
        description: 'Storage locations',
        href: '/admin/inventory/locations',
        icon: MapPin
      },
      {
        name: 'Transfers',
        description: 'Item transfers',
        href: '/admin/inventory/transfers',
        icon: ArrowLeftRight
      }
    ]
  },
  {
    name: 'Re-Commerce',
    description: 'Re-commerce operations',
    href: '/admin/re-commerce/resale',
    icon: RefreshCw,
    items: [
      {
        name: 'Resale',
        description: 'Resale management',
        href: '/admin/re-commerce/resale',
        icon: Repeat,
        items: [
          {
            name: 'Items',
            description: 'Resale items',
            href: '/admin/re-commerce/resale/items',
            icon: Package
          },
          {
            name: 'Orders',
            description: 'Resale orders',
            href: '/admin/re-commerce/resale/orders',
            icon: ShoppingCart
          },
          {
            name: 'Analytics',
            description: 'Resale analytics',
            href: '/admin/re-commerce/resale/analytics',
            icon: LineChart
          },
          {
            name: 'Environment',
            description: 'Environmental impact',
            href: '/admin/re-commerce/resale/environment',
            icon: Leaf
          }
        ]
      },
      {
        name: 'Repair',
        description: 'Repair operations',
        href: '/admin/re-commerce/repairs',
        icon: Wrench,
        items: [
          {
            name: 'List',
            description: 'Repair list',
            href: '/admin/re-commerce/repairs/list',
            icon: Box
          },
          {
            name: 'Technicians',
            description: 'Repair technicians',
            href: '/admin/re-commerce/repairs/technicians',
            icon: Users
          },
          {
            name: 'Program',
            description: 'Repair program',
            href: '/admin/re-commerce/repairs/program',
            icon: Settings
          },
          {
            name: 'Analytics',
            description: 'Repair analytics',
            href: '/admin/re-commerce/repairs/analytics',
            icon: LineChart
          }
        ]
      },
      {
        name: 'Refill',
        description: 'Refill management',
        href: '/admin/re-commerce/refill',
        icon: Droplet,
        items: [
          {
            name: 'Dashboard',
            description: 'Refill overview',
            href: '/admin/re-commerce/refill',
            icon: LayoutDashboard
          },
          {
            name: 'Containers',
            description: 'Refill containers',
            href: '/admin/re-commerce/refill/containers',
            icon: Box
          },
          {
            name: 'Stations',
            description: 'Refill stations',
            href: '/admin/re-commerce/refill/stations',
            icon: MapPin
          },
          {
            name: 'Subscriptions',
            description: 'Refill subscriptions',
            href: '/admin/re-commerce/refill/subscriptions',
            icon: Repeat
          },
          {
            name: 'Returns',
            description: 'Refill returns',
            href: '/admin/re-commerce/refill/returns',
            icon: ArrowLeftRight
          },
          {
            name: 'Analytics',
            description: 'Refill analytics',
            href: '/admin/re-commerce/refill/analytics',
            icon: LineChart
          },
          {
            name: 'Settings',
            description: 'Refill settings',
            href: '/admin/re-commerce/refill/settings',
            icon: Settings
          }
        ]
      },
      {
        name: 'Rental',
        description: 'Rental management',
        href: '/admin/re-commerce/rental',
        icon: Car,
        items: [
          {
            name: 'Items',
            description: 'Rental items',
            href: '/admin/re-commerce/rental/items',
            icon: Package
          },
          {
            name: 'Orders',
            description: 'Rental orders',
            href: '/admin/re-commerce/rental/orders',
            icon: ShoppingCart
          },
          {
            name: 'Program',
            description: 'Rental program',
            href: '/admin/re-commerce/rental/program',
            icon: Settings
          },
          {
            name: 'Analytics',
            description: 'Rental analytics',
            href: '/admin/re-commerce/rental/analytics',
            icon: LineChart
          }
        ]
      },
      {
        name: 'Recycling',
        description: 'Recycling operations',
        href: '/admin/re-commerce/recycle',
        icon: Recycle,
        items: [
          {
            name: 'Programs',
            description: 'Recycling programs',
            href: '/admin/re-commerce/recycle/programs',
            icon: Package
          },
          {
            name: 'Collection',
            description: 'Collection points',
            href: '/admin/re-commerce/recycle/collection',
            icon: MapPin
          },
          {
            name: 'Analytics',
            description: 'Recycling analytics',
            href: '/admin/re-commerce/recycle/analytics',
            icon: LineChart
          },
          {
            name: 'Environment',
            description: 'Environmental impact',
            href: '/admin/re-commerce/recycle/environment',
            icon: Leaf
          }
        ]
      }
    ]
  }
];

// Helper function to find active navigation item including sub-items
export function getActiveNavigation(pathname) {
  let active = null;
  let parent = null;

  // Helper function to check nested items
  const checkItems = (items, currentParent) => {
    for (const item of items) {
      if (pathname.startsWith(item.href)) {
        active = item;
        parent = currentParent;
        // Check for deeper nesting
        if (item.items) {
          checkItems(item.items, item);
        }
        return true;
      }
    }
    return false;
  };

  // Check top level items
  for (const item of navigation) {
    if (pathname.startsWith(item.href)) {
      active = item;
      // Check sub-items if they exist
      if (item.items) {
        checkItems(item.items, item);
      }
      break;
    }
  }

  return { active, parent };
}

// Helper function to get navigation item by href
export function getNavigationItem(href) {
  let result = null;

  // Helper function to check nested items
  const checkItems = (items, currentParent) => {
    for (const item of items) {
      if (item.href === href) {
        result = { parent: currentParent, item };
        return true;
      }
      if (item.items && checkItems(item.items, item)) {
        return true;
      }
    }
    return false;
  };

  // Check top level items
  for (const item of navigation) {
    if (item.href === href) {
      result = { parent: null, item };
      break;
    }
    if (item.items && checkItems(item.items, item)) {
      break;
    }
  }

  return result;
}
